import React from "react";
import Header from "../components/Header";
import Hero from "../components/Hero";
import About from "../components/About";
import Services from "../components/Services";
import Packages from "../components/Packages";
import Method from "../components/Method";
import Team from "../components/Team";
import AppShowcase from "../components/AppShowcase";
import Testimonials from "../components/Testimonials";
import Social from "../components/Social";
import Contact from "../components/Contact";
import Footer from "../components/Footer";
import WhatsAppFloat from "../components/WhatsAppFloat";

export default function Home() {
    return (
        <div className="relative min-h-screen bg-ink text-white" data-testid="home-page">
            <Header />
            <main>
                <Hero />
                <About />
                <Services />
                <Packages />
                <Method />
                <Team />
                <AppShowcase />
                <Testimonials />
                <Social />
                <Contact />
            </main>
            <Footer />
            <WhatsAppFloat />
        </div>
    );
}
